export const businessDetails1 = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: business details: personal details: business category',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  formStart: () => ({
    event_name: 'form_start',
    page_name: 'vodapay: business advance: opf: business details: personal details: business category',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business details 1'
  }),

  formEnd: (actionName) => ({
    event_name: 'ui_interaction,  form_end',
    page_name: 'vodapay: business advance: opf: business details: personal details: business category',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business details 1',
    link_id: `vodapay: business advance: opf: business details: personal details: business category: ${actionName}`
  })
};

export const businessDetails2 = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: business details 2',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  formStart: () => ({
    event_name: 'form_start',
    page_name: 'vodapay: business advance: opf: business details 2',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business details 2'
  }),

  formEnd: () => ({
    event_name: 'ui_interaction,  form_end',
    page_name: 'vodapay: business advance: opf: business details 2',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business details 2',
    link_id: 'vodapay: business advance: opf: next',
    time_in_business: '<insert amount>',
    business_revenue: '<insert annual revenue>',
    source_of_income: '<insert source>'
  })
};

export const businessAddress = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: business address',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  formStart: () => ({
    event_name: 'form_start',
    page_name: 'vodapay: business advance: opf: business address',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business address'
  }),

  formEnd: () => ({
    event_name: 'ui_interaction,  form_end',
    page_name: 'vodapay: business advance: opf: business address',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business address',
    link_id: 'vodapay: business advance: opf: next'
  })
};

export const businessDirectors = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  formStart: () => ({
    event_name: 'form_start',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business directors'
  }),

  addDirector: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: business details: director details: add director'
  }),

  saveDirector: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: business details: director details: save director'
  }),

  deleteDirector: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: business details: director details: director deleted'
  }),

  deleteDirectorPopup: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: business details: director details: delete director popup'
  }),

  cancelDeleteDirector: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: business details: director details: cancel director deletion'
  }),

  cancelAddNewDirector: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: business details: director details: cancel add new director'
  }),

  formEnd: (clickButton) => ({
    event_name: 'ui_interaction,  form_end',
    page_name: 'vodapay: business advance: opf: business details: director details',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business directors',
    link_id: `vodapay: business advance: opf: business details: director details: ${clickButton}`
  })
};
